import React, { useMemo } from 'react';

import { Table } from 'components/Table/Table';
import { jobCols, transformJobData } from 'root/components/Table/tableRef';

import { useQuery } from '@apollo/client';
import { GET_JOBS } from '@constants/gql';

import { Job } from 'types';

const jobTableColumnDef = [
	jobCols.name, 
	jobCols.jobStepStatus,
	jobCols.workflow,
	jobCols.startAt,
	jobCols.stopAt,
	jobCols.duration,
	jobCols.progressMeter
];


export function JobsHistoryTable(
) {
	const {
		loading,
		error,
		data: { job: jobs } = { job: [] as Array<Job> }
	} = useQuery(GET_JOBS);

	const columns = useMemo(() => jobTableColumnDef, [])

	const data = useMemo(() => transformJobData(jobs), [jobs.length]);

	if (loading) { return <p>Loading...</p>; }
	else if (error) { return <p>Error :(</p>; }

	return (
		<Table
			columns={columns}
			data={data}
			hasSortableColumns
			hasFilterableColumns
			hasGlobalFilter
			hasPagination
			hasSelectablePageSize
		/>
	)
}